
export default class BookItem {
    target = null;
    /**@type {PageItemControl} */
    itemControl = null;
    /** 
    *@type {number} 
    */
    id = undefined;

    constructor(el, target) {
        this.el = el;
        this.target = target;

        if (this.target.getChildByName("anti")) {
            this.target.getChildByName("anti").visible = false;
        }
        if(this.target.parent.tag == "page") {
            this.pageId = this.target.parent.id
        }

        /**
         * 目前按鈕顯示狀態
         * 
         * true = 開啟顯示中
         * 
         * false = 關閉顯示中
         */
        this.isOpen = false;

        /**
         * 主按鈕群組，裝此按鈕的主按鈕
         * 
         * 通常是子按鈕在請求主按鈕做事時使用
         */
        this.mainGroup = [];

        /**
         * 子按鈕群組，裝此按鈕的子按鈕
         * 
         * 通常是主按鈕在請求子按鈕做事時使用
         */
        this.childGroup = [];
    }

    /**
     * RT
     */
    init() {

    }

    /**
     * 要在init結束後執行的特殊需求可在這裡處理
     * 
     * 執行位置 pageItem_control.js 179
     */
    initLate() {

    }

    /**
     * 按鈕點擊用
     */
    trigger() {

    }

    /**
     * start 在所有物件初始化後觸發
     */
    start() {
    }

    addSingleAntialiasing(obj) {
        obj.target.visible = false;
        obj.itemControl.loader.singleAntialiasing(obj.target);
    }

    /**
     * 子按鈕通知主按鈕檢查
     */
    ChildNotice() {
        // console.log("ChildNotice");
        // console.log("this.mainGroup",this.mainGroup);
        this.mainGroup.forEach(element => {
            element.TestCheck();
        });
    }
}